import { formatPercent } from 'modules/I18N';
import { EChartsOption } from 'echarts';
import { GetChartData, GetNetValue } from '../BidsRenderer.types';

export const getChartData: GetChartData = ({ bidRequest, bidResponse }) => [
  {
    name: 'Requests',
    value: bidRequest ?? 0,
  },
  {
    name: 'Responses',
    value: bidResponse ?? 0,
  },
];

export const getNetValue: GetNetValue = ({ bidRequest, bidResponse, wonImpressions, localeCode }) => {
  if (bidRequest && bidRequest !== 0 && wonImpressions && bidResponse)
    return formatPercent({ value: wonImpressions / bidResponse, localeCode });
  return formatPercent({ value: 0, localeCode });
};

export const getChartOptions = (): EChartsOption => ({
  backgroundColor: 'transparent',
  series: [
    {
      type: 'pie',
      emphasis: {
        disabled: true,
      },
    },
  ],
});
